import classNames from 'classnames';
import React from 'react';

import {UI_REGION} from '@udemy/browse-utils';
import {Image} from '@udemy/react-core-components';
import {MinimalHeader} from '@udemy/react-structure-components';
import {
    ConsumerSubscriptionPlan,
    ConsumerSubscriptionValuePlan,
    SubscriptionPlanContext,
} from '@udemy/subscription-graphql';

import {
    useNonCatalogCheckoutSource,
    usePersonalPlanSubscriptionCheckoutEntry,
} from '../../personal-plan-subscription-checkout-entry-context';
import {PersonalPlanSubscriptionCTA} from '../personal-plan-subscription-cta/personal-plan-subscription-cta.react-component';
import styles from './consumer-subscription-sticky-header.module.less';

export interface PersonalPlanStickyHeaderProps {
    label: string;
    visible: boolean;
    subscriptionContext?: SubscriptionPlanContext<
        ConsumerSubscriptionPlan | ConsumerSubscriptionValuePlan
    >;
    persistentSearch?: boolean;
}

const logo =
    'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/v7/logo-udemy.svg';

export const ConsumerSubscriptionStickyHeader = ({
    label,
    visible,
    subscriptionContext,
    persistentSearch = false,
}: PersonalPlanStickyHeaderProps) => {
    const subscriptionCheckoutEntry = usePersonalPlanSubscriptionCheckoutEntry();
    const {source: nonCatalogSource, noticeDataLoading: nonCatalogNoticeDataLoading} =
        useNonCatalogCheckoutSource();

    const renderLogo = persistentSearch
        ? () => <></>
        : () => <Image src={logo} alt="Udemy" className={styles.logo} />;

    return (
        <div
            className={classNames(styles['consumer-subscription-sticky-header'], {
                [styles['slide-out']]: !visible,
                [styles['with-persistent-search']]: persistentSearch && visible,
            })}
            data-testid={'consumer-subscription-sticky-header'}
        >
            <MinimalHeader className={styles.header} renderLogo={renderLogo}>
                <div className={classNames('ud-text-lg', styles['title'])}>{label}</div>

                <div className={styles['plan-purchase']}>
                    <PersonalPlanSubscriptionCTA
                        className={styles['subscription-cta']}
                        uiRegion={UI_REGION.STICKY_HEADER}
                        plan={subscriptionContext}
                        subscriptionCheckoutEntry={subscriptionCheckoutEntry}
                        source={nonCatalogSource}
                        noticeDataLoading={nonCatalogNoticeDataLoading}
                    />
                </div>
            </MinimalHeader>
        </div>
    );
};
